import { z } from 'zod'

import { ExerciseApi } from '../api'
import { getApiConfig } from './api-config'
import { yearWeekSchema } from './dal-utils'

export const goalDtoSchema = z.object({
  yearWeek: z.number(),
  value: z.number(),
})

export async function fetchExerciseGoal(yearWeek?: string) {
  const exerciseApi = new ExerciseApi(getApiConfig())
  const parsedYearWeek =
    yearWeek == null ? undefined : yearWeekSchema.parse(yearWeek)
  const dto = await exerciseApi.apiExerciseGoalGet({ yearWeek: parsedYearWeek })
  const parsedGoal = goalDtoSchema.parse(dto)

  return parsedGoal.value
}

export async function setExerciseGoal(value: number) {
  if (!Number.isInteger(value) || value <= 0) {
    throw new Error('Exercise goal must be a positive integer')
  }

  const exerciseApi = new ExerciseApi(getApiConfig())
  try {
    await exerciseApi.apiExerciseGoalPost({ value })
  } catch (error) {
    if (error instanceof Response) {
      const responseBody = await error.text().catch(() => '')
      throw new Error(
        responseBody || `Request failed with status ${error.status}`,
      )
    }

    throw error
  }
}
